import { Component } from '@angular/core';
import { ActiveIngredientService } from '../../active-ingredient.service';
import {
  ACTIVE_INGREDIENT_TTL_ES,
  IActiveIngredient
} from '../../active-ingredient.interface';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';

@Component({
  selector: 'pg-active-ingredient-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class ActiveIngredientSelectComponent extends SelectTemplate {
  constructor(private serviceBase: ActiveIngredientService) {
    super(ACTIVE_INGREDIENT_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: ACTIVE_INGREDIENT_TTL_ES,
      columns: [{ header: 'Descripción', field: 'description' }]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IActiveIngredient[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
